<div class="modal-header bg-dark">
    <h4 class="modal-title">Upload <strong>Documento</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<form (ngSubmit)="onSubmit()" #inspectionImportForm="ngForm" role="form"
      class="form-horizontal form-validation">
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12">
                <div class="row" style="margin-top: 80px; margin-bottom: 80px;">
                    <div class="col-md-12">
                        <div class="form-group">
                            <label for="document" class="col-sm-3 control-label">Documento *</label>
                            <div class="col-sm-3">
                                    <span class="input-group-btn">
                                        <label class="btn btn-sm btn-primary">Seleziona File
                                            <input type="file"
                                                   id="document"
                                                   name="document"
                                                   (change)="onFileSelected($event)"
                                                   required
                                                   hidden>
                                        </label>
                                    </span>
                            </div>
                            <div class="col-sm-6">
                                <input type="text"
                                       id="inspection-document"
                                       name="inspection-document"
                                       class="form-control-plaintext"
                                       style="font-size: 1.4rem !important;"
                                       readonly
                                       [ngModel]="fileName || 'Nessun file selezionato'">
                            </div>
                        </div>

                        <div *ngIf="inspectionDocumentUploadResult === false" class="alert alert-danger">
                            Impossibile caricare il file, verificarne il formato e riprovare.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit"
                class="btn btn-embossed btn-default btn-blue"
                [disabled]="!inspectionImportForm.form.valid || fileName === ''">
            <i class="fa fa-upload"></i> Esegui Upload
        </button>
        <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.dismiss()">Chiudi</button>
    </div>
</form>
